import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderPage from "../../components/HeaderPage";
import {
  ActionIcon,
  Badge,
  Button,
  Divider,
  Group,
  Loader,
  Modal,
  Paper,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { useGetDiagnostiqueQuery } from "./api/features/diagnostiqueApi";
import { Check, Edit, Eye, Trash } from "tabler-icons-react";
// import DeleteAction from "./actions/DeleteAction";
import {
  useAddDiagnosticsNiveauMutation,
  useDeleteDiagnosticsNiveauMutation,
  useEditDiagnosticsNiveauMutation,
} from "./api/features/mutationsApi";
import EditAction from "./actions/EditAction";
import { useDisclosure } from "@mantine/hooks";
import { useForm } from "@mantine/form";
import { useGetNiveauxQuery } from "../../redux/features/niveauApi";
import AddAction from "./actions/AddAction";

function DiagnostiqueListeDetails() {
  const params = useParams();
  const navigation = useNavigate();
  const location = useLocation();

  const [editItem, setEditItem] = useState(null);
  const [seuil, setSeuil] = useState(0);
  const [opened, { open, close }] = useDisclosure(false);

  const { data, isLoading, refetch } = useGetDiagnostiqueQuery(
    parseInt(location?.state?.id)
  );
  // console.log({ location: location?.state?.id });

  useEffect(() => {
    // Use a hardcoded token for now, replace with your auth logic if needed
    const token = localStorage.getItem('token') || '';
    if (data?.data?.niveaux && data.data.niveaux.length > 0 && data.data.diagnostic?.id) {
      const updateSeuils = async () => {
        let updated = false;
        for (const niveau of data.data.niveaux) {
          try {
            const response = await fetch(
              `https://recette-backend.genimi.io/api/v1/m1/epreuves/?diagnosticId=${data.data.diagnostic.id}&niveauId=${niveau.niveauId.id}`,
              { headers: { "Accept": "application/json" } }
            );
            const epreuveData = await response.json();
            const epreuves = epreuveData?.data || [];
            const totalBareme = epreuves.reduce((sum, e) => sum + (parseInt(e.bareme) || 0), 0);
            if (totalBareme !== niveau.seuil) {
              console.log(`Auto-updating seuil for niveau ${niveau.niveauId.name}: ${niveau.seuil} -> ${totalBareme}`);
              await fetch(
                `https://recette-backend.genimi.io/api/v1/diagnostics/niveaux/${niveau.id}/`,
                {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-CSRFToken": token
                  },
                  body: JSON.stringify({ seuil: totalBareme })
                }
              );
              updated = true;
            } else {
              console.log(`No update needed for niveau ${niveau.niveauId.name}: seuil is already ${niveau.seuil}`);
            }
          } catch (err) {
            console.error(`Failed to auto-update seuil for niveau ${niveau.niveauId.name}:`, err);
          }
        }
        if (updated) {
          // Refetch the niveaux list to update the UI
          await refetch();
        }
      };
      updateSeuils();
    }
  }, [data?.data?.niveaux, data?.data?.diagnostic?.id, refetch]);

  const form = useForm({
    initialValues: {
      niveauId: "",
      seuil: "",
      diagnosticId: location?.state?.id,
    },

    validate: {},
  });

  const [deleteDiagnosticsNiveau, { isLoading: deleteLoading }] =
    useDeleteDiagnosticsNiveauMutation();
  const [editDiagnosticsNiveau, { isLoading: updateLoading }] =
    useEditDiagnosticsNiveauMutation();

  const [addDiagnosticsNiveau, { isLoading: addNiveauxLoadign }] =
    useAddDiagnosticsNiveauMutation();

  const { data: niveaux } = useGetNiveauxQuery();

  return (
    <div>
      <Group position="apart">
        <HeaderPage
          navigation={navigation}
          title={"Diagnostics " + location?.state?.title}
        />
        <Button
          disabled={isLoading || data?.data?.niveaux.length >= 3}
          onClick={open}
        >
          Ajouter niveau
        </Button>
      </Group>
      <Divider my={10} />

      {isLoading ? (
        <Loader />
      ) : (
        data?.data?.niveaux.map((item, index) => (
          <Paper withBorder key={index} mb={10} p={10}>
            <Group position="apart">
              <Text weight={500}>{item?.niveauId?.name}</Text>
              <Group spacing={40}>
                <Group>
                  <Text weight={500}>Seuil :</Text>
                  {editItem && editItem === item.id ? (
                    <TextInput
                      size="xs"
                      radius={20}
                      w={70}
                      type="number"
                      value={seuil}
                      onChange={(e) => setSeuil(e.target.value)}
                    />
                  ) : (
                    <Badge>{item?.seuil}</Badge>
                  )}
                </Group>
                <Group>
                  {editItem && editItem === item.id ? (
                    <ActionIcon
                      color="green"
                      onClick={async () => {
                        await EditAction(
                          editDiagnosticsNiveau,
                          { seuil: parseInt(seuil), id: parseInt(item?.id) },
                          ""
                        );
                        setEditItem(null);
                      }}
                      variant="filled"
                      loading={item.id === editItem && updateLoading}
                    >
                      <Check size={18} />
                    </ActionIcon>
                  ) : (
                    <ActionIcon
                      color="green"
                      onClick={() => {
                        setEditItem(item?.id);
                        setSeuil(parseInt(item.seuil));
                      }}
                    >
                      <Edit size={18} />
                    </ActionIcon>
                  )}
                  {/* <ActionIcon
                    color="red"
                    onClick={async () => {
                      await DeleteAction(deleteDiagnosticsNiveau, item?.id);
                      setEditItem(null);
                    }}
                    loading={item.id === editItem && deleteLoading}
                  >
                    <Trash size={18} />
                  </ActionIcon> */}
                  <Button
                    onClick={() =>
                      navigation(
                        // `${data?.data?.diagnostic?.id}/${item?.niveauId?.id}`,
                        `${item?.niveauId?.name}`,
                        {
                          state: {
                            niveauName: item?.niveauId?.name,
                            diagnosticId: data?.data?.diagnostic?.id,
                            niveauId: item?.niveauId?.id,
                          },
                        }
                      )
                    }
                    leftIcon={<Eye size={18} />}
                    size="xs"
                  >
                    {/* {console.log(data?.data)} */}
                    voir les exercices
                  </Button>
                </Group>
              </Group>
            </Group>
          </Paper>
        ))
      )}

      {/* Modal */}
      <Modal opened={opened} onClose={close} title={"Ajout niveaux"}>
        <form
          onSubmit={form.onSubmit(async (values) => {
            // Set seuil to 0 when creating
            await AddAction(addDiagnosticsNiveau, { ...values, seuil: 0 });
            close();
            form.reset();
          })}
        >
          <Select
            placeholder="Selection un niveau"
            withAsterisk
            sx={{ flex: 1 }}
            {...form.getInputProps("niveauId")}
            data={
              niveaux
                ? niveaux?.data
                  .filter(
                    (item) =>
                      item?.matiereId === data?.data?.diagnostic.matiereId
                  )
                  .map((item) => ({
                    label: item?.name,
                    value: item?.id,
                  }))
                : []
            }
          />
          <Text c="dimmed" size="sm" mt={10}>
            Le seuil sera calculé automatiquement après l'ajout des exercices.
          </Text>

          <Divider my={20} />

          <Group position="right">
            <Button variant="light" onClick={close}>
              Annuler
            </Button>
            <Button type="submit" loading={addNiveauxLoadign}>
              Ajouter
            </Button>
          </Group>
        </form>
      </Modal>
    </div>
  );
}

export default DiagnostiqueListeDetails;
